import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { DefaultFilter } from "../../../../@types/filter";
import { AttendanceLocalService } from "../../../../@types/attendance-local-service";
import { Paginated } from "../../../../@types/paginated";
import { apisiseci } from "../../../api";
import { useDefaultSearchParams } from "../../../../hooks/useSearchParams";
import { AttendanceLocal } from "../../../../@types/attendance-local";
import { AttendanceLocalDepartmentGuiche } from "../../../../@types/attendance-local-department-guiche";
import { AttendanceLocalDepartment } from "../../../../@types/attendance-local-department";

type Props = DefaultFilter & {
    unidade_slug?: AttendanceLocal["slug_unidade"];
    setor_unidade?: AttendanceLocalDepartment["id"];
    guiche_id?: AttendanceLocalDepartmentGuiche["id"];
    fila?: boolean;
};

export function useAttendanceLocalServiceList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    return useQuery<Paginated<AttendanceLocalService>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['attendance-local', 'service', 'list', params],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<AttendanceLocalService>>(
                "/cms/servicos_unidades/",
                { headers: { Authorization: `Bearer ${token}` }, params }
            );
            return response.data;
        },
    });
}
